
import { defineComponent, ref, inject, reactive } from 'vue';
import dayjs from 'dayjs';
import { useStore } from "vuex";
import relativeTime from 'dayjs/plugin/relativeTime';
import Form from './Form.vue'


export default defineComponent({
components: {
    Form
  },
  setup() {
    const store = useStore();

    const comments = ref<Comment[]>([]);
    const submitting = ref<boolean>(false);
    const value = ref<string>('');
    const invoice = inject<any>('invoice');
    const message_form = ref<InstanceType<typeof Form>>();
    const form = reactive({
        invoice_id:'',
        vendor_id:window.localStorage.getItem('PAYMENT_PORTAL_VENDOR_ID') as any,
        message:'',
        invoice_user_id: ''
    })

    const handleSubmit = () => {
        form.invoice_id = invoice.id
        form.invoice_user_id = invoice.user_id
        form.message = value.value

        if (!value.value) {
            return;
        }

        submitting.value = true;

        setTimeout(() => {
            store.dispatch("InvoiceQueryVendor/store",form).then((res:any) => {
                store.dispatch('VendorInvoice/show',form.invoice_id).then((res:any) => {
                  invoice.invoice_queries = res.data.invoice_queries
                  submitting.value = false;
                })
            })
            
            value.value = '';
        }, 1000);
    };

    const edit = (record: any) => {
      message_form.value?.edit(record);
    };

    return {
      comments,
      submitting,
      value,
      invoice,
      form,
      message_form,
      edit,
      handleSubmit,
    };
  },
});
